import { Link } from "react-router-dom";

const ProductCard = ({
  imageUrl,
  title,
  description,
  buttonText = "View Details",
  link,
}) => {
  return (
    <Link to={link}>
      <div className="group w-full bg-white dark:bg-gray-800 border transition-all duration-300 hover:scale-105 relative overflow-hidden">
        {/* Image Container */}
        <div className="relative w-full overflow-hidden">
          {/* Product Image */}
          <img
            src={imageUrl}
            alt={title}
            className="w-full h-full object-cover transition-transform duration-300"
          />

          {/* Slide-up Button */}
          <button className="absolute bottom-0 left-0 opacity-0 translate-y-4 w-full border-0 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300 bg-black text-white dark:bg-gray-800 px-4 py-2 shadow-md ">
            {buttonText}
          </button>
        </div>

        {/* Content Container */}
        <div className="p-4 space-y-2">
          <h3 className="text-lg font-semibold truncate dark:text-white">
            {title}
          </h3>
          <p className="text-gray-500 dark:text-gray-300 line-clamp-2">
            {description}
          </p>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
